export default __webpack_public_path__ + "0cf8b0d6882d73a9ae87a1e1183713f7.png";